import {useCallback} from 'react';
import {toast} from 'react-toastify';
import {useParams} from 'react-router-dom';
import {ButtonBack, Divider, Spinner, Transitioner} from 'components';
import {useCreateSubscriptionUrl, useGetPlans, type PlanType} from 'api/generated';
import {useMe} from 'hooks';

import PlansTable from './plans-table/Plans.Table';

interface IPlansMineProps {}

const PlansMine = ({}: IPlansMineProps) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  const me = useMe();
  const currentPlan = me?.plan;

  const {data: plansData} = useGetPlans();
  const plans = plansData?.data?.data ?? [];

  const createSubscriptionUrl = useCreateSubscriptionUrl();
  const handleSubscribe = useCallback(async (plan: PlanType) => {
    const {data: res} = await createSubscriptionUrl.mutateAsync({data: {planUid: plan.uid}});
    if (res.data?.success) {
      const url = res.data.message;
      window.location.href = url;
    } else if (res.data?.message) {
      toast.error(res.data.message);
    } else if (res.errors) {
      toast.error(res.errors[0].detail);
    }
  }, []);

  return (
    <Transitioner>
      <ButtonBack url={`/${workspace}/billing`} />
      <Divider />
      <div className="sm:flex-auto">
        <h1 className="font-medium text-lg dark:text-white">Select a plan</h1>
        <p className="mt-2 text-sm text-gray-700 dark:text-darkText">Upgrade and unlock features with a subscription plan.</p>
      </div>
      <Divider />
      <Transitioner delay={0.1}>
        {plansData && currentPlan ? (
          <PlansTable plans={plans} currentPlan={currentPlan} onSubscribe={handleSubscribe} />
        ) : (
          <div className="flex justify-center py-10">
            <Spinner />
          </div>
        )}
      </Transitioner>
    </Transitioner>
  );
};

export default PlansMine;
